export const wireInstructionMessages = {
  submitSuccess: "Your wire instruction submitted successfully.",
  confirmDialog: {
    Internal: {
      header: "Submit Internal Funds Wire Update",
      body: "This wire update request will be submitted only for the **Internal Funds** you selected. To request an update to any external wire instructions, you will need to submit a separate request via the **External Fund Info** tab.",
    },
    External: {
      header: "Submit External Funds Wire Update",
      body: "This wire update request will be submitted only for the **External Funds** you selected. To request an update to any internal wire instructions, you will need to submit a separate request via the **Internal Fund Info** tab.",
    },
  },
} as const;

export type WireFundType = keyof typeof wireInstructionMessages.confirmDialog;
